<template>
  <div class="animated fadeIn">
    <b-row>
      <div class="card"
        style="width: 100%; border-radius: 1em; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); margin: 10px; margin-top: 0px; padding-bottom: 0px;">
        <div style="padding-top: 23px; padding-left: 23px; padding-right: 23px;">

          <div class="mb-3" style="padding:2px;">
            <img src="/ui/img/rule-icon.png" width="23" height="23" alt="user image" style="margin-right:5px">
            <span style="font-size: 20px; color: #00B695; vertical-align: middle;"><b> Pattern</b></span>
            <span style="font-size: 20px; color: #7A7A7A; vertical-align: middle;"><b> Status</b></span>
            <b-button class="float-right" variant="light" size="sm" @click="pushRouter('uwss_pattern')"><b>+ </b></b-button>
            <!-- <b-button class="mr-1 float-right" variant="success" size="sm" @click="pushRouter('rule', 'add')"><b>Register</b></b-button> -->
          </div>

          <!-- line 2 -->
          <div class="loading" v-if="loading">
            <div class="spinner"></div>
          </div>
          <b-row v-else>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #1abc9c; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>URL</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="url" :count="summary.total.url" color="#1abc9c" />
                  </template>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #e67e22; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>Host</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="host" :count="summary.total.host" color="#e67e22"/>
                  </template>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #e74c3c; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>IP</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="ip" :count="summary.total.ip" color="#e74c3c" />
                  </template>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- line 2 -->
          <b-row>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #9b59b6; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>Regex</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="regex" :count="summary.total.regex" color="#9b59b6" />
                  </template>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #2980b9; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>Path</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="path" :count="summary.total.path" color="#2980b9"/>
                  </template>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #f39c12; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>SSDEEP</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="file_ssdeep" :count="summary.total.file_ssdeep" color="#f39c12" />
                  </template>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- line 3 -->
          <b-row>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #c0392b; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>Executable File</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="file_excute" :count="summary.total.file_excute" color="#c0392b"/>
                  </template>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #16a085; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>File Hash</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="file_hash" :count="summary.total.file_hash" color="#16a085" />
                  </template>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #8e44ad; margin-right: 5px;"></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>Webshell</b></span>
                </div>
                <div class="p-1">
                  <template>
                    <DoughnutChart v-if="!loading" chartId="file_excute" :count="summary.total.file_webshell" color="#8e44ad"/>
                  </template>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- chart -->
          <b-row>
            <b-col>
              <div class="card" style="border-radius: 1em;">
                <div class="card-body">
                  <i class="fa fa-thumb-tack" aria-hidden="true" style="color: #00B695; margin-right: 2px; "></i>
                  <span style="font-size: 1em; color: #7A7A7A; vertical-align: middle;"><b>최근 7일간 등록된 패턴 수 </b></span>
                  <!-- <span style="font-size: 18px; color: #00B695; vertical-align: middle;"><b>( 기간 : {{ substarctNowDate }} ~ {{ nowDate }} )</b></span> -->

                  <div class="chart" style="padding-top : 15px;">
                    <template>
                      <LineChart v-if="!loading" :days="summary.day"/>
                    </template>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-row>

    <!--License 부분-->
    <!-- <b-row >
      <b-col md="3">
        <b-card v-if="!loading" no-header style="border-radius: 1em; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);">
          <div style="padding: 5px;">
              <div class="mb-3" style="padding:2px;">
                <img src="/ui/img/license-icon.png" width="23" height="23" alt="user image" style="margin-right:5px">
                <b><span style="font-size: 20px; color: #1E97EE; vertical-align: middle;"> License</span></b>
                <b-button class="float-right" variant="light" size="sm" @click="pushRouter('uwss_license')"><b>+</b></b-button>
              </div>
              <div class="card" style="background-color: #1E97EE; border-radius: 1em; margin-bottom: 5px;">
                <div class="card-head" style="margin-left: 20px; margin-top: 10px;">
                  <span style="font-size: 17px; color: white;" class="card-title"><b class="top-medium-text">Total </b></span>
                  <span style="font-size: 30px; color: white;" class="card-title"><b class="top-large-text"> {{ summary.license.enable + summary.license.disable }}</b></span>
                </div>
                <hr style="border: solid 1px white; margin-top: 4px; margin-left: 20px; margin-right: 20px;">
                <div class="card" style="margin-left: 20px; margin-right: 20px; margin-bottom: 10px; background-color: #1E97EE; border: none;">
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Enable : {{ summary.license.enable }}</b></div>
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Disable : {{ summary.license.disable }}</b></div>
                </div>
              </div>
            </div>
        </b-card>
      </b-col>
      <b-col md="3">
        <b-card v-if="!loading" no-header style="border-radius: 1em; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);">
          <div style="padding: 5px;">
              <div class="mb-3" style="padding:2px;">
                <img src="/ui/img/license-icon.png" width="23" height="23" alt="user image" style="margin-right:5px">
                <b><span style="font-size: 20px; color: #1E97EE; vertical-align: middle;"> WSFinder</span></b>
              </div>
              <div class="card" style="background-color: #1E97EE; border-radius: 1em; margin-bottom: 5px;">
                <div class="card-head" style="margin-left: 20px; margin-top: 10px;">
                  <span style="font-size: 17px; color: white;" class="card-title"><b class="top-medium-text">Total </b></span>
                  <span style="font-size: 30px; color: white;" class="card-title"><b class="top-large-text"> {{ summary.license.wsfinder_status.enable + summary.license.wsfinder_status.disable }}</b></span>
                </div>
                <hr style="border: solid 1px white; margin-top: 4px; margin-left: 20px; margin-right: 20px;">
                <div class="card" style="margin-left: 20px; margin-right: 20px; margin-bottom: 10px; background-color: #1E97EE; border: none;">
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Enable : {{ summary.license.wsfinder_status.enable }}</b></div>
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Disable : {{ summary.license.wsfinder_status.disable }}</b></div>
                </div>
              </div>
            </div>
        </b-card>
      </b-col>
      <b-col md="3">
        <b-card v-if="!loading" no-header style="border-radius: 1em; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);">
          <div style="padding: 5px;">
              <div class="mb-3" style="padding:2px;">
                <img src="/ui/img/license-icon.png" width="23" height="23" alt="user image" style="margin-right:5px">
                <b><span style="font-size: 20px; color: #1E97EE; vertical-align: middle;"> WEBCastle</span></b>
              </div>
              <div class="card" style="background-color: #1E97EE; border-radius: 1em; margin-bottom: 5px;">
                <div class="card-head" style="margin-left: 20px; margin-top: 10px;">
                  <span style="font-size: 17px; color: white;" class="card-title"><b class="top-medium-text">Total </b></span>
                  <span style="font-size: 30px; color: white;" class="card-title"><b class="top-large-text"> {{ summary.license.webcastle_status.enable + summary.license.webcastle_status.disable }}</b></span>
                </div>
                <hr style="border: solid 1px white; margin-top: 4px; margin-left: 20px; margin-right: 20px;">
                <div class="card" style="margin-left: 20px; margin-right: 20px; margin-bottom: 10px; background-color: #1E97EE; border: none;">
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Enable : {{ summary.license.webcastle_status.enable }}</b></div>
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Disable : {{ summary.license.webcastle_status.disable }}</b></div>
                </div>
              </div>
            </div>
        </b-card>
      </b-col>
      <b-col md="3">
        <b-card v-if="!loading" no-header style="border-radius: 1em; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);">
          <div style="padding: 5px;">
              <div class="mb-3" style="padding:2px;">
                <img src="/ui/img/license-icon.png" width="23" height="23" alt="user image" style="margin-right:5px">
                <b><span style="font-size: 20px; color: #1E97EE; vertical-align: middle;"> WMDS</span></b>
              </div>
              <div class="card" style="background-color: #1E97EE; border-radius: 1em; margin-bottom: 5px;">
                <div class="card-head" style="margin-left: 20px; margin-top: 10px;">
                  <span style="font-size: 17px; color: white;" class="card-title"><b class="top-medium-text">Total </b></span>
                  <span style="font-size: 30px; color: white;" class="card-title"><b class="top-large-text"> {{ summary.license.wmds_status.enable + summary.license.wmds_status.disable }}</b></span>
                </div>
                <hr style="border: solid 1px white; margin-top: 4px; margin-left: 20px; margin-right: 20px;">
                <div class="card" style="margin-left: 20px; margin-right: 20px; margin-bottom: 10px; background-color: #1E97EE; border: none;">
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Enable : {{ summary.license.wmds_status.enable }}</b></div>
                  <div style="font-size: 16px; color: white;" class="card-title"><b class="bottom-medium-text">Disable : {{ summary.license.wmds_status.disable }}</b></div>
                </div>
              </div>
            </div>
        </b-card>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import LineChart from './components/LineChart.vue';
import DoughnutChart from './components/DoughnutChart.vue'
import moment from 'moment-timezone';
import { api } from '@/f1/service';

export default {
  name: 'Dashboard',
  components: {
    LineChart,
    DoughnutChart,
    moment,
  },

  data: () => ({

    loading : false,
    summary : {
      total : {
        file_binary : 0,
        file_excute : 0,
        file_hash : 0,
        file_ssdeep : 0,
        host : 0,
        path : 0,
        hash : 0,
        ip : 0,
        url : 0,
      },
      license : {
        active : 0,
        deactive : 0,
        group_status : { enable: 0, disable: 0 },
        user_status : { enable: 0, disable: 0 },
        webcastle_status : { enable: 0, disable: 0 },
        wfdetect_status : { enable: 0, disable: 0 },
        wmds_status : { enable: 0, disable: 0 },
        wsfinder_status : { enable: 0, disable: 0 },
      },
      day : [],
    }
  }),

  methods: {
    pushRouter(name, id, tag) {
      this.$router.push({ name: name, params: { id: id, tag: tag } });
    },

    async load() {
      try {
        this.loading = true
        let rv = await api.dashboard.summary.get();
        console.log('[vue] welcome', 'Get summary', rv);
        this.summary = Object.assign({}, this.summary, rv)
        this.loading = false
      }
      catch (e) { this.$toastr.e(e); }
    }
  },

  watch: { '$route'(to, from) { this.get(to.params); console.log(from) } },

  created() { console.log('[vue] welcome', 'created'); },
  destroyed() { console.log('[vue] welcome', 'destroyed'); },
  mounted() { console.log('[vue] welcome', 'mounted'); this.load(); }
}

</script>

<style>
@media (max-width : 1300px) {

  b.top-large-text {
    font-size: 22px;
  }

  b.top-medium-text {
    font-size: 15px;
  }

  b.bottom-medium-text {
    font-size: 14px;
  }

}
</style>

